import { render, staticRenderFns } from "./T1Onas.vue?vue&type=template&id=33ac4100&"
var script = {}
import style0 from "./T1Onas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports